import { render, staticRenderFns } from "./FooterDark.vue?vue&type=template&id=2369f32e&scoped=true&"
import script from "./FooterDark.vue?vue&type=script&lang=js&"
export * from "./FooterDark.vue?vue&type=script&lang=js&"
import style0 from "./FooterDark.vue?vue&type=style&index=0&id=2369f32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369f32e",
  null
  
)

export default component.exports